<template>
	<b-card no-body class="pt-4">
		<!-- <FilterDrawer ref="drawer_filter_customer" :agents_list="agentsList" @filter_assigned_to="filterAssignedTo($event[0], $event[1], $event[2])" /> -->
		<FilterDrawer ref="drawer_filter_customer" :agents_list="agentsList" :customer_status_list="customerSubStatusList"
			@filter_assigned_to="filterAssignedTo($event)" />
		<CustomersAssignToModal :show_assign_customers_to.sync="modals.show_assign_customers_to" :agents_list="agentsList"
			:customer_details="selectedCustomerRow" :multiple_selection="selectedRows" :show_ssa="showSSA" :show_sse="showSSE"
			:show_hub_manager="showHubManager" v-on:closeModal="closeAssignModal()" />
		<CustomerSetStatusModal :show_set_customers_status.sync="modals.show_set_customers_status"
			:customer_sub_status_list="customerSubStatusList" :multiple_selection="selectedRows" />
		<CustomerCreateJointModal :show_create_joint_customer.sync="modals.show_create_joint_customer"
			:multiple_selection="selectedRows" />
		<CustomerImportModal @importSuccess="getCustomers" ref="customer_import_modal" />

		<b-row>
			<b-col cols="12">
				<button type="button" class="btn-icon-clipboard">
					<router-link to="/customersCalendar">
						<div>
							<i class="ni ni-calendar-grid-58"></i>
							<span>Calendar View</span>
						</div>
					</router-link>

				</button>
			</b-col>
		</b-row>
		<b-row class="mb-4 mx-3">
			<b-col cols="12" class="px-0 mb-1">
				<p class="font-weight-bold text-muted">Profile Type</p>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="profile_type === 1 ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
					@click="selectProfileButton(1)">
					<span class="font-weight-600">All</span><br>
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="profile_type === 2 ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
					@click="selectProfileButton(2)">
					<span class="font-weight-600">Single Profile</span><br>
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="profile_type === 3 ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
					@click="selectProfileButton(3)">
					<span class="font-weight-600">Joint Profile</span><br>
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="profile_type === 4 ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
					@click="selectProfileButton(4)">
					<span class="font-weight-600">Monitoring Profile</span><br>
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="profile_type === 5 ? 'primary' : 'outline-primary'" class="mb-2 mr-2 shadow-none"
					@click="selectProfileButton(5)">
					<span class="font-weight-600">Beyond TAT</span><br>
				</b-button>
			</b-col>
		</b-row>

		<b-row class="mb-4 mx-3">
			<b-col cols="12" class="px-0 mb-1" v-if="Object.keys(card_filters).length > 0">
				<p class="font-weight-bold text-muted">Main Status</p>
			</b-col>
			<b-col cols="6" md="auto" class="px-1" v-for="(value, key, index) in card_filters" :key="index">
				<b-button block :variant="filters.cardStatus === key ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" :class="[
						(['New Leads', 'Missing Status'].includes(key) ? (!_gAuth.isAppSas() || _gHlp.checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director']) ? '' : 'd-none') : ''),
						(['New Leads', 'Missing Status'].includes(key) && value <= 0 ? 'd-none' : '')
					]" @click="selectFilterButton(key)">
					<span class="font-weight-600">{{ key }}</span><br>
					{{ value }}
				</b-button>
			</b-col>
		</b-row>

		<b-row class="mb-4 mx-3">
			<b-col cols="12" class="px-0 mb-1" v-if="Object.keys(card_filters).length > 0">
				<p class="font-weight-bold text-muted">Period</p>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'all' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('all')">
					<span class="font-weight-600">All</span><br>
					{{ periodCounts.all }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'today' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('today')">
					<span class="font-weight-600">Today</span><br>
					{{ periodCounts.today }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'yesterday' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('yesterday')">
					<span class="font-weight-600">Yesterday</span><br>
					{{ periodCounts.yesterday }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === '7_days' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('7_days')">
					<span class="font-weight-600">7 Days</span><br>
					{{ periodCounts['7_days'] }}

				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === '30_days' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('30_days')">
					<span class="font-weight-600">30 Days</span><br>
					{{ periodCounts['30_days'] }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'this_week' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('this_week')">
					<span class="font-weight-600">This Week</span><br>
					{{ periodCounts.this_week }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'last_week' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('last_week')">
					<span class="font-weight-600">Last Week</span><br>
					{{ periodCounts.last_week }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'this_month' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('this_month')">
					<span class="font-weight-600">This Month</span><br>
					{{ periodCounts.this_month }}
				</b-button>
			</b-col>
			<b-col cols="6" md="auto" class="px-1">
				<b-button block :variant="filters.period === 'last_month' ? 'primary' : 'outline-primary'"
					class="mb-2 mr-2 shadow-none" @click="filterPeriod('last_month')">
					<span class="font-weight-600">Last Month</span><br>
					{{ periodCounts.last_month }}
				</b-button>
			</b-col>
		</b-row>

		<b-row class="mb-4 mx-3">
			<b-col cols="12" md="12" class="px-1 d-flex  align-items-end justify-content-between">
				<div class="px-1 d-flex align-items-end justify-content-start">
					<div>
						<!-- <b-form-group label="Filter By Corporate" v-if="_gAuth.isAppSas()" class="mb-0 mr-2">
							<el-select v-model="filters.corporate" placeholder="Select Corporate">
								<el-option label="" value="">All</el-option>
								<el-option v-for="item in corporateList" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</b-form-group> -->
						<b-form-group label="Filter By Corporate" v-if="_gAuth.isAppSas()" class="mb-0 mr-2">
							<base-input
								v-model="searchTerm"
								placeholder="Type to search corporate..."
								@input="onSearch"
								@keyup.enter="onEnterKey"
							/>

							<ul v-if="showSuggestions && filteredCorporates.length" class="dropdown-menu show w-100 shadow-sm">
								<li
									class="dropdown-item"
									v-for="item in filteredCorporates"
									:key="item.id"
									@click="selectCorporate(item)"
									style="cursor: pointer"
								>
									{{ item.name }}
								</li>
							</ul>
						</b-form-group>
					</div>
					<div>
						<el-button class="mx-0 mr-2" type="primary"
							v-if="hasSelectedData && _gHlp.checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director'])"
							@click="bulkAssignToModal">
							Assign To
						</el-button>

						<el-button class="mx-0 mr-2" type="outline-primary"
							v-if="hasSelectedData && (_gHlp.checkAppCodeAndRoleType(['vps'], ['admin', 'corporate']) || _gAuth.isCorporateOwner()) && _gHlp.checkAccess(['c_customer__delete'])"
							@click="bulkDeleteRow(selectedRows)">
							Bulk Delete
						</el-button>

						<el-button class="mx-0 mr-2" type="outline-primary"
							v-if="hasSelectedData && _gHlp.checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director'])"
							@click="modals.show_set_customers_status = true">
							Set Status
						</el-button>

						<el-button class="mx-0 mr-2" type="outline-primary" v-if="hasSelectedData" @click="showCreateJointCustomer">
							<b-icon icon="people-fill" class="mr-2"></b-icon>
							Joint Profile
						</el-button>

						<!-- <el-button class="mx-0 mr-2 bg-dark text-white" v-if="tableData.length > 0 && _gAuth.isCorporateOwner()" @click="exportLead"
										:loading="is_loading_export"><b-icon icon="box-arrow-left"></b-icon> Export
								</el-button> -->

						<el-button type="secondary" v-if="_gHlp.checkAccess(['allow_customer_bulk_upload'])"
							@click="$refs.customer_import_modal.show()">
							<b-icon icon="box-arrow-in-right"></b-icon> Import
						</el-button>
					</div>
				</div>
				<div>
					<el-button type="default" v-if="_gHlp.checkIsCorporateSubscription()"
						@click="$refs.drawer_filter_customer.viewFilterCustomer()">
						<b-icon icon="filter"></b-icon> Filter
					</el-button>
					<base-input v-else v-model="filters.searchQuery" v-on:input="debouncedHandler" prepend-icon="fas fa-search"
						placeholder="Search">
					</base-input>
				</div>
			</b-col>
		</b-row>

		<div class="table-listings">
			<!-- <el-alert
                v-if="selectedRows.length > 0"
                effect="dark"
                class="alert-customer-profile"
                @close="emptySelection"
            >
                <b-row align-h="between" align-v="center">
                    <b-col cols="12" md="4">
                        <p class="text-white">
                            <span class="font-weight-700">{{ selectedRows.length }}</span> Selected
                        </p>
                    </b-col>
                    <b-col cols="12" md="8" class="d-flex align-items-center" v-if="_gHlp.checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director'])">
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="bulkAssignToModal">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="22" height="14" viewBox="0 0 640 512"><path fill="currentColor" d="M96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312v-64h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h64v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24h-64v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                            <p class="text-white">Assign To</p>
                        </div>
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="modals.show_set_customers_status = true">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="14" height="18" viewBox="0 0 448 512"><path fill="currentColor" d="M0 80v149.5c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80zm112 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"/></svg>
                            <p class="text-white">Set Status</p>
                        </div>
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="showCreateJointCustomer">
                            <h3 class="text-white mb-0"><b-icon icon="people-fill" class="mr-2"></b-icon></h3>
                            <p class="text-white">Joint Profile</p>
                        </div>
                    </b-col>
                    <b-col cols="12" md="8" class="d-flex align-items-center" v-else>
                        <div class="d-flex align-items-center cursor-pointer mx-3" @click="showCreateJointCustomer">
                            <h3 class="text-white mb-0"><b-icon icon="people-fill" class="mr-2"></b-icon></h3>
                            <p class="text-white">Joint Profile</p>
                        </div>
                        <div class="d-flex align-items-center cursor-pointer mx-3"  v-if="(_gHlp.checkAppCodeAndRoleType(['vps'], ['admin', 'corporate']) || _gAuth.isCorporateOwner()) && _gHlp.checkAccess(['c_customer__delete'])" @click="bulkDeleteRow(selectedRows)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mx-2" width="14" height="18" viewBox="0 0 1408 1536"><path fill="currentColor" d="M512 1248V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23m256 0V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23m256 0V544q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23M480 256h448l-48-117q-7-9-17-11H546q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5H288q-66 0-113-58.5T128 1336V384H32q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23"/></svg>
                            <p class="text-white">Bulk Delete</p>
                        </div>
                    </b-col>
                </b-row>
            </el-alert> -->
			<el-table ref="multipleTable" v-loading="isTableLoading" :data="tableData" style="width: 100%"
				@selection-change="selectionChange">
				<el-table-column type="selection" width="35" class-name="individual-table-name px-2"></el-table-column>

				<!-- MESSAGE BOX -->
				<el-table-column v-if="auth_user.subscription.privileges.scpk_crm_chat_massage" :fixed="isFixed" width="70"
					class-name="icons-chat">
					<template slot-scope="scope">
						<MessagingBoxButton :type="'customer'" :profile="scope.row" />
					</template>
				</el-table-column>
				<el-table-column :fixed="isFixed" class-name="icons-joint" width="45">
					<template slot-scope="scope">
						<svg v-b-tooltip.hover="'Joint Profile'" v-if="scope.row.cjp_id" xmlns="http://www.w3.org/2000/svg"
							width="32" height="32" viewBox="0 0 24 24">
							<path fill="none" stroke="#48D498" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M6 9h6M4 5h4M6 5v11a1 1 0 0 0 1 1h5m0-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z" />
						</svg>
						<svg v-else xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
							<path fill="none" stroke="#DEE5EF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
								d="M6 9h6M4 5h4M6 5v11a1 1 0 0 0 1 1h5m0-9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm0 8a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z" />
						</svg>
					</template>
				</el-table-column>

				<el-table-column prop="name" label="Name/ID" min-width="250" width="auto" :fixed="isFixed"
					class-name="individual-table-name" sortable>
					<template slot-scope="scope">
						<div class="d-flex align-items-center justify-content-between">
							<div v-if="_gHlp.checkAppCode('sas')">
								<h3 v-b-tooltip.hover="'Personal Lead'" v-if="scope.row.type === 'Personal'" class="mb-0 mr-3"><b-icon
										icon="person-fill"></b-icon></h3>
								<h3 v-b-tooltip.hover="'Company Lead'" v-else-if="scope.row.type === 'Company'" class="mb-0 mr-3">
									<b-icon icon="building"></b-icon></h3>
								<h3 v-else class="mr-4 pr-2 mb-0"></h3>
							</div>
							<div class="w-100 column-name d-flex align-items-center">
								<div>
									<el-tooltip effect="dark" placement="right">
										<div slot="content" class="d-flex align-items-center">
											<svg xmlns="http://www.w3.org/2000/svg" class="cursor-pointer"
												@click.prevent="copyToClipboard(scope.row)" width="14" height="18" viewBox="0 0 448 512">
												<path fill="currentColor"
													d="M208 0h124.1C344.8 0 357 5.1 366 14.1L433.9 82c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64v256h192v-32h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
											</svg>
										</div>
										<router-link :to="'/customerProfileDetails/' + scope.row.customer_id + '?active=overview'">
											<p class="font-weight-500 text-primary" v-if="!scope.row.cjp_id">{{ scope.row.name |
												formatUserName(20) }}</p>
											<div v-else>
												<p class="font-weight-500 text-primary"
													v-for="(joint_profile, index) in scope.row.customer_joint_profiles" :key="index">{{
														joint_profile.name | formatUserName(20) }}</p>
											</div>
										</router-link>
									</el-tooltip>
									<div class="mb-0 text-black font-weight-bold badge badge-primary px-2 py-1 text-left"
										v-if="$route.path == '/loanAdvisoryListingCount' && scope.row.corporate != null && scope.row.additional_detail && scope.row.additional_detail.application_code">
										{{ scope.row.additional_detail.application_code
										}}</div>
									<div class="d-flex align-items-center">	
										<span class="mb-0 bottom-line mr-1">{{ _gHlp.checkAppCode('vps') ? scope.row.masked_id :
											scope.row.customer_id }}</span>
										<CustomerChannelPopover 
										v-if="!_gHlp.isEmpty(scope.row.duplicate_customer_id) && !_gHlp.isEmpty(scope.row.channel) && _gHlp.checkAccess(['role_admin', 'role_corporate', 'role_super_admin'])" 
										:customer_name="scope.row.name" 
										:customer_contact_no="scope.row.contact_no" 
										:customer_created_at="scope.row.created_at" 
										:channel_name="scope.row.channel ? scope.row.channel.name : '-'" 
										/>	
									</div>
									<i class="fa fa-exclamation-triangle text-danger mx-2 cursor-pointer" v-if="scope.row.send_to_advisory &&
										_gHlp.checkAppCodeAndRoleType(['sas'], ['admin', 'manager', 'director']) &&
										(!scope.row.ssa)
									" @click="assignToModal(scope.row, true, true)"></i>
								</div>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column width="55" class-name="text-center" :fixed="isFixed">
					<template slot-scope="scope">
						<svg
							v-b-tooltip.hover="_gHlp.checkIsCorporateSubscription() ? BASKET_DESCRIPTION[scope.row.basket.basket_color] : ''"
							xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="rounded"
							:style="{ 'background': BASKET_COLOR[scope.row.basket.basket_color], 'padding': '0.125rem' }">
							<path fill="#fff"
								d="M21 9h-1.42l-3.712-6.496-1.736.992L17.277 9H6.723l3.146-5.504-1.737-.992L4.42 9H3a1.001 1.001 0 0 0-.965 1.263l2.799 10.264A2.005 2.005 0 0 0 6.764 22h10.473c.898 0 1.692-.605 1.93-1.475l2.799-10.263A.998.998 0 0 0 21 9zm-3.764 11v1-1H6.764L4.31 11h15.38l-2.454 9z" />
							<path fill="#fff" d="M9 13h2v5H9zm4 0h2v5h-2z" />
						</svg>
					</template>
				</el-table-column>

				<!-- PRODUCT CASE -->
				<el-table-column width="120">
					<template #header>
						<div class="d-flex flex-column">
							<div>Product</div>
						</div>
					</template>
					<template slot-scope="scope">
						<el-tooltip
							v-if="!_gHlp.isEmpty(scope.row.additional_detail) && scope.row.additional_detail.looking_for_product"
							placement="bottom" effect="dark">
							<div slot="content">
								{{ MAIN_PRODUCTS_LABEL[scope.row.additional_detail.looking_for_product] }}
							</div>
							<b-avatar size="32px"
								:text="_gHlp.formatInitials(MAIN_PRODUCTS_LABEL[scope.row.additional_detail.looking_for_product])"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="proposal" label="Proposals" width="120"
					v-if="_gHlp.checkAppCode('sas') && $route.path != '/loanAdvisoryListingCount'">
					<template slot-scope="scope">
						<div class="text-center">
							<svg id="cases-svg" width="50" height="50">
								<circle cx="25" cy="25" r="18" stroke="#EC6F00" stroke-width="2" fill="#FF9A00" />
								<text x="25" y="30" text-anchor="middle" fill="#FFF" class="cases-text">{{
									scope.row.counts.count_proposal || '0' }}</text>
							</svg>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="cases" label="Cases" width="100">
					<template slot-scope="scope">
						<svg id="cases-svg" width="50" height="50">
							<circle cx="25" cy="25" r="18" stroke="#5d79e3" stroke-width="2" fill="#dce2f9" />
							<text x="25" y="30" text-anchor="middle" fill="#5d79e3" class="cases-text">{{
								scope.row.counts.count_case_product || '0' }}</text>
						</svg>
					</template>
				</el-table-column>

				<!-- SUB STATUS -->
				<el-table-column v-if="!($route.path == '/loanAdvisoryListingCount' && _gAuth.isActvCorpIn([50])) " prop="status" label="Sub Status" min-width="150" width="auto">
					<template slot-scope="scope">
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<el-dropdown trigger="click" v-model="customerStatus">
									<p class="el-dropdown-link top-line">
										<span v-if="scope.row.status" v-b-tooltip.hover="scope.row.status.sub.status">{{
											scope.row.status.sub.status | shortenText(16) }}</span>
										<span v-else>-</span>

										<i class="el-icon-caret-bottom el-icon--right"></i>
									</p>
									<el-dropdown-menu slot="dropdown">
										<div style="max-height: 300px;overflow-y: auto;">
											<el-dropdown-item v-for="status in customerSubStatusList" :key="status.status_id"
												@click.native="updateCustomerStatus(scope.row.customer_id, status.status_id, scope.row.additional_detail.application_code)">
												<span class="font-weight-bold">{{ status.parent_status }}</span> - {{ status.status }}
											</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
							<div>
								<el-popover
									v-if="!_gHlp.isEmpty(scope.row.status.tat_summary) && !_gHlp.isEmpty(scope.row.status.tat_summary.tat_at)"
									placement="top-start" title="Date Tracking" trigger="hover">
									<p v-if="_gHlp.isEmpty(scope.row.status.tat_summary.tat_stop_at)">
										<small class="mb-0 d-block">Last Update : {{ scope.row.status.tat_summary.tat_at |
											dateFormatString}}</small>
										<small class="mb-0 d-block" :style="{ 'color': scope.row.status.tat_summary.tat_color }">Due Date :
											{{ scope.row.status.tat_summary.due_at | dateFormatString }}</small>
										<small class="mb-0 d-block"
											:style="{ 'color': scope.row.status.tat_summary.tat_color }">{{ scope.row.status.tat_summary.remain_label }}</small>
									</p>
									<p v-else>
										<small class="mb-0 d-block">Create Date : {{ scope.row.status.tat_summary.tat_created_at |
											dateFormatString}}</small>
										<small class="mb-0 d-block">Stop Date : {{ scope.row.status.tat_summary.tat_stop_at |
											dateFormatString}}</small>
										<small class="mb-0 d-block"><strong>TOTAL : {{ scope.row.status.tat_summary.tat_total }}
												Days</strong></small>
									</p>
									<i slot="reference" class="el-icon-info"
										:style="{ 'color': scope.row.status.tat_summary.tat_color }"></i>
								</el-popover>
							</div>
						</div>
					</template>
				</el-table-column>

				<!-- SPECIAL REQ IMONEY -->
				<el-table-column v-if="_gAuth.isActvCorpIn([50]) && $route.path == '/loanAdvisoryListingCount'" min-width="150" width="auto" >
					<template #header>
						<div class="d-flex flex-column">
							<small>SAS Advisory</small>
							<small>Main Status</small>
						</div>
					</template>
					<template slot-scope="scope">
						<p>{{ _gHlp.getValue(scope.row,'partner_advisory_status.main.status') }}</p>
					</template>
				</el-table-column>
				<el-table-column v-if="($route.path == '/loanAdvisoryListingCount' && _gAuth.isActvCorpIn([50])) " prop="status" label="SAS Sub Status" min-width="150" width="auto">
					<template #header>
						<div class="d-flex flex-column">
							<small>SAS Advisory</small>
							<small>Sub Status</small>
						</div>
					</template>
					<template slot-scope="scope">
						<p>{{ _gHlp.getValue(scope.row,'partner_advisory_status.sub.status') }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="incomes.main.net_income" min-width="180" width="auto" sortable :sort-by="customSortKey">
					<template #header>
						<div class="d-flex flex-column">
							<div>Net Income</div>
							<div>/Commit (DSR)</div>
						</div>
					</template>
					<template slot-scope="scope">
						<p class="mb-0 top-line">RM {{ (Number(scope.row.incomes ? scope.row.incomes.main.net_income : '0' |
							moneyFormatter)) }}</p>
						<p class="mb-0 bottom-line">RM {{ scope.row.incomes ? scope.row.incomes.main.total_commitment : '0' |
							moneyFormatter }} &nbsp;({{ scope.row.incomes ? (scope.row.incomes.main.dsr ?
								scope.row.incomes.main.dsr + '%' : '0.00%') : '0.00%' }})
						</p>
					</template>
				</el-table-column>

				<!-- CREATED BY -->
				<el-table-column prop="created_by" label="Created By" width="120">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.created_by_detail" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ scope.row.created_by_detail.name }}
							</div>
							<b-avatar size="32px" :src="scope.row.created_by_detail.avatar_url"
								:text="_gHlp.formatInitials(scope.row.created_by_detail.name)"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="hub_manager" label="Hub Manager" width="120"
					v-if="_gHlp.checkAppCode('sas') && $route.path == '/loanAdvisoryListingCount'">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.hub_manager" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ scope.row.hub_manager.name }}
							</div>
							<b-avatar class="cursor-pointer" size="32px" :src="scope.row.hub_manager.avatar_url"
								:text="_gHlp.formatInitials(scope.row.hub_manager.name)"
								@click.native="assignToModal(scope.row, false, false, true)"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<!-- AGENT -->
				<el-table-column prop="assigned_to" :label="_gAuth.isAppSas() ? 'TM' : 'Agent'" width="120">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.se" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ scope.row.se.name }}
							</div>
							<b-avatar size="32px" :src="scope.row.se.avatar_url"
								:text="_gHlp.formatInitials(scope.row.se.name)"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="SSA" label="SSA" width="120" v-if="_gAuth.isAppSas()">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.ssa" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ scope.row.ssa.name }}
							</div>
							<b-avatar class="cursor-pointer" size="32px" :src="'#'" :text="_gHlp.formatInitials(scope.row.ssa.name)"
								@click.native="assignToModal(scope.row, true, false)"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column prop="SSE" label="SSE" width="120" v-if="_gAuth.isAppSas()">
					<template slot-scope="scope">
						<el-tooltip v-if="scope.row.sse" placement="bottom" effect="dark">
							<div slot="content">
								Name: {{ scope.row.sse.name }}
							</div>
							<b-avatar class="cursor-pointer" size="32px" :src="scope.row.sse.avatar_url"
								:text="_gHlp.formatInitials(scope.row.sse.name)"
								@click.native="assignToModal(scope.row, false, true)"></b-avatar>
						</el-tooltip>
						<div v-else>
							<span style="font-size: 1.5rem">-</span>
						</div>
					</template>
				</el-table-column>

				<el-table-column min-width="200" width="auto" prop="channel.name" v-if="_gAuth.isAppSas()" sortable>
					<template #header>
						<div class="d-flex flex-column">
							<div>Channel</div>
							<div>/Platform</div>
						</div>
					</template>
					<template slot-scope="scope">
						<div class="d-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
								<path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" />
							</svg>
							<p class="mb-0 top-line" v-if="scope.row.channel">{{ scope.row.channel.name }}</p>
							<p class="mb-0 top-line" v-else-if="scope.row.corporate != null">{{ getAltChannel(scope.row.corporate) }}
							</p>
							<p class="mb-0 top-line" v-else>N/A</p>
						</div>
						<div class="d-flex align-items-center">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
								<path fill="currentColor" d="M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10Z" />
							</svg>
							<p class="mb-0 bottom-line" v-if="scope.row.platform">{{ scope.row.platform.name }}</p>
							<p class="mb-0 bottom-line" v-else-if="scope.row.corporate != null">{{ getAltPlatform(scope.row.corporate)
								}}</p>
							<p class="mb-0 bottom-line" v-else>N/A</p>
						</div>
					</template>
				</el-table-column>
				<!-- Advisory Status Column for non-SAS -->
				<el-table-column v-if="!_gAuth.isActvCorpIn([1,50])" min-width="100" width="auto">
					<template #header>
						<div class="d-flex flex-column">
							<div>Advisory Status</div>
						</div>
					</template>
					<template slot-scope="scope">
						<div class="d-flex align-items-center justify-content-between">
							<div>
								<el-dropdown trigger="click" v-model="customerStatus">
									<p class="el-dropdown-link top-line">
										<span v-if="scope.row.loan_advisory_status && scope.row.loan_advisory_status.sub.status != null"
											v-b-tooltip.hover="scope.row.loan_advisory_status.sub.status">{{
												scope.row.loan_advisory_status.sub.status | shortenText(16) }}</span>
										<span v-else>-</span>
										<i class="el-icon-caret-bottom el-icon--right"></i>
									</p>
									<el-dropdown-menu slot="dropdown">
										<div style="max-height: 300px;overflow-y: auto;">
											<el-dropdown-item v-for="status in loanAdvisorySubStatusList" :key="status.status_id"
												@click.native="updateCustomerAdvisoryStatus(scope.row.customer_id, status.status_id)">
												<span class="font-weight-bold">{{ status.parent_status }}</span> - {{ status.status }}
											</el-dropdown-item>
										</div>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column min-width="200">
					<template #header>
						<div class="d-flex flex-column">
							<div>Appointment At</div>
						</div>
					</template>
					<template slot-scope="scope">
						<div class="d-flex align-items-center">
							<p v-if="!_gHlp.isEmpty(scope.row.appointment_at)" class="mb-0 top-line mx-1">{{
								scope.row.appointment_at | dateTimeFormatString }}</p>
							<i v-if="!_gHlp.isEmpty(scope.row.appointment_at)"
								@click="exportToGoogleCalendar(scope.row.appointment_at, scope.row.name)" class="el-icon-date"></i>
							<p v-else>-</p>
						</div>
					</template>
				</el-table-column>
				<!-- CREATED DATE | TAT -->
				<el-table-column prop="created_at" min-width="150" width="auto" :fixed="isFixed"
					class-name="individual-table-name">
					<template #header>
						<div class="d-flex flex-column">
							<div>Created Date / TAT</div>
						</div>
					</template>
					<template slot-scope="scope">
						<p class="mb-0 top-line" v-if="scope.row.created_at">{{ scope.row.created_at | dateFormatString }}</p>
						<p v-else>-</p>
						<p class="mb-0 bottom-line"
							v-if="!_gHlp.isEmpty(scope.row.status.tat_summary) && !_gHlp.isEmpty(scope.row.status.tat_summary.tat_at)">
							<TatDatePopover :tat_summary="scope.row.status.tat_summary" />
							{{ (!_gHlp.isEmpty(scope.row.status.tat_summary.tat_stop_at) ? scope.row.status.tat_summary.tat_stop_at :
								scope.row.status.tat_summary.tat_at) | dateFormatString }}
						</p>
						<p v-else>-</p>
					</template>
				</el-table-column>
				<el-table-column fixed="right"
					v-if="(_gHlp.checkAppCodeAndRoleType(['vps'], ['admin', 'corporate']) || _gAuth.isCorporateOwner()) && _gHlp.checkAccess(['c_customer__delete'])">
					<template slot-scope="scope">
						<el-dropdown trigger="click" style="cursor: pointer">
							<p class="el-dropdown-link mb-0 top-line">
								<b-icon icon="three-dots-vertical"></b-icon>
							</p>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="deleteRow(scope.row)">Delete</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>
				</el-table-column>

				<!-- <el-table-column
                    fixed="right"
                    width="20"
                    class-name="px-1"
                >
                    <template slot-scope="scope">
                        <p class="mb-0 top-line">
                            <b-icon icon="three-dots-vertical"></b-icon>
                        </p>
                    </template>
                </el-table-column> -->
			</el-table>
		</div>

		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap">
			<div class="d-flex align-items-center mb-3">
				<p class="card-category mb-0 text-secondary">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries

					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>

				<span class="mb-0 ml-4">Rows:</span>

				<el-select class="select-primary pagination-select mx-2" v-model="pagination.perPage" placeholder="Per page"
					@change="perPageChanged">
					<el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
						:value="item">
					</el-option>
				</el-select>

			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

	</b-card>
</template>
<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Tooltip, Popover, Select, Option, Button, Badge, Tag, DatePicker, Alert } from 'element-ui'
import { BasePagination } from '@/components'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useConfigStore } from '@/stores/configStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { mapState, mapActions } from 'pinia'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
	axios,
	services,
	getHeader,
	debounce,
	swal,
} from '@/assets/js/httpImports.js'
import { BASKET_COLOR } from '@/assets/js/colors.js'
import mainEventBus from '@/assets/js/mainEventBus'
import FilterDrawer from '@/views/CustomerProfile/CustomerProfileListings/FilterDrawer'
import CustomersAssignToModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CustomersAssignToModal'
import CustomerSetStatusModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CustomerSetStatusModal'
import CustomerCreateJointModal from '@/views/CustomerProfile/CustomerModals/CustomerTable/CustomerCreateJointModal'
import CustomerImportModal from '@/views/CustomerProfile/CustomerModals/CustomerImport/CustomerImportModal'
import TatDatePopover from '@/views/Widgets/TatDatePopover'
import MessagingBoxButton from '@/views/Messaging/MessagingBoxButton'
import { CAN_ASSIGN_ROLE_IDS } from '@/assets/js/roles.js'
import { BASKET_DESCRIPTION, MAIN_PRODUCTS_LABEL } from '@/assets/js/status.js'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { useNotificationStore } from '@/stores/notificationStore'
import CustomerChannelPopover from '@/views/Widgets/CustomerChannelPopover'
export default {
	name: 'customer-profile-listing-individual-table',
	props: ['is_page_advisory'],
	mixins: [clientPaginationMixin],
	components: {
		TatDatePopover,
		BasePagination,
		FilterDrawer,
		CustomersAssignToModal,
		CustomerSetStatusModal,
		CustomerCreateJointModal,
		CustomerImportModal,
		MessagingBoxButton,
		CustomerChannelPopover,
		[Select.name]: Select,
		[Option.name]: Option,
		[Tooltip.name]: Tooltip,
		[Popover.name]: Popover,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Dropdown.name]: Dropdown,
		[DropdownItem.name]: DropdownItem,
		[DropdownMenu.name]: DropdownMenu,
		[Button.name]: Button,
		[Badge.name]: Badge,
		[Tag.name]: Tag,
		[DatePicker.name]: DatePicker,
		[Alert.name]: Alert,
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useCustomerStore, ['listing_current_page', 'filter_query']),
		...mapState(useConfigStore, ['app_code']),
		...mapState(useAccessControlStore, ['corporateList', 'userList']),
		...mapState(useMessagingStore, ['sms_template_list']),
		hasSelectedData() {
			return this.selectedRows.length > 0;
		},
		filteredCorporates() {
			const term = this.searchTerm.toLowerCase();
			if (!term) return this.corporateList;
			return this.corporateList.filter(item =>
				item.name.toLowerCase().includes(term)
			);
		}
	},
	data() {
		return {
			isTableLoading: true,
			BASKET_DESCRIPTION: BASKET_DESCRIPTION,
			MAIN_PRODUCTS_LABEL: MAIN_PRODUCTS_LABEL,
			BASKET_COLOR: BASKET_COLOR,
			propsToSearch: ['name'],
			isFixed: true,
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			searchText: '',
			debouncedHandler: '',
			TableColumn: [{
				type: 'selection'
			}],
			statusOption: [{
				value: 'Excellent',
				label: 'Excellent'
			}, {
				value: 'Good',
				label: 'Good'
			}, {
				value: 'Fair',
				label: 'Fair'
			}, {
				value: 'Poor',
				label: 'Poor'
			}, {
				value: 'V.Poor',
				label: 'V.Poor'
			}, {
				value: 'Uncompleted',
				label: 'Uncompleted'
			}],
			status: [],
			selects: {
				filter: [],
			},
			filterOptions: [],
			filterBy: '',
			tableData: [],
			randomStatus: null,
			customerStatusList: [],
			customerSubStatusList: [],
			customerStatus: "NA",
			customerAdvisoryStatus: "NA",
			loanAdvisorySubStatusList: [],//for SAS status when access from VPS
			card_filters: [],
			periodCounts: {
				all: 0,
				today: 0,
				yesterday: 0,
				'7_days': 0,
				'30_days': 0,
				this_week: 0,
				last_week: 0,
				this_month: 0,
				last_month: 0
			},
			CAN_ASSIGN_ROLE_IDS: CAN_ASSIGN_ROLE_IDS,
			// filters.cardStatus: "All",
			sub_status: [],
			value1: "",
			selectedDates: [],
			modals: {
				show_assign_customers_to: false,
				show_set_customers_status: false,
				show_create_joint_customer: false,
			},
			agentsList: [],
			selectedCustomerRow: {},
			showSSA: true,
			showSSE: false,
			showHubManager: false,
			filters: {
				monitoring: '',
				beyond_tat: '',
				customer_id: "",
				customer_name: "",
				income_type_id: "",
				status: "",
				se: "",
				ssa: "",
				sse: "",
				cardStatus: "All",
				searchQuery: "",
				// created_at: ""
				created_at: "",
				updated_at: "",
				end_date: "",
				channel: "",
				platform: "",
				is_joint: "",
				core_product: "",
				corporate: "",
				created_by: "",
				period: "today",
			},
			profile_type: 1,
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			searchTerm: "",
			showSuggestions: false,
		};
	},
	watch: {
		'filters.corporate'(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.handleFilterChangeCorporate(newVal)
			}
		}
	},
	async created() {
		if (this.$route.query.page > 0) {
			this.currentPageChanged(this.$route.query.page)
		}

		if (this.app_code === 'dahongye') {
			this.pagination.perPage = 50
		} else {
			this.pagination.perPage = 25
		}

		if (Object.keys(this.filter_query).length === 0) {
			history.pushState({}, null, this.$route.path + '?page=' + this.listing_current_page)
		} else {
			this.filterAssignedTo(this.filter_query)
		}

		this.pagination.currentPage = this.listing_current_page
		this.getCustomers()
		this.getCustomerStatus()
		this.getLoanAdvisoryStatus()
		this.getCustomerCountHandler()
		await this.getUsers(_gAuth.activeCorporateId())
		this.agentsList = this.userList
		this.getSmsTemplates();
		this.filteredCorporates = this.corporateList; 
	},
	mounted() {
		this.setFixed();
		window.addEventListener('resize', this.setFixed);

		mainEventBus.$on('refresh-table-data', this.refreshTableData)

		this.debouncedHandler = debounce(() => {
			this.selectedFilterButton = 'All'
			this.getCustomers();
		}, 500);

	},
	beforeDestroy() {
		window.removeEventListener('resize', this.setFixed);
	},
	beforeUnmount() {
		mainEventBus.$off('refresh-table-data', this.refreshTableData)
	},
	methods: {
		...mapActions(useCustomerStore, ['getCustomerCount', 'currentPageChanged', 'setFilterQuery', 'updateCustomerAdvisoryStat']),
		...mapActions(useMessagingStore, ['getProfileListMessagesSummaries', 'getSmsTemplates']),
		...mapActions(useNotificationStore, ['createNotification', 'fetchNotificationTemplate']),
		...mapActions(useAccessControlStore, ['getUsers']),
		onSearch() {
			this.showSuggestions = !!this.searchTerm;
		},
		selectCorporate(item) {
			this.filters.corporate = item.id;
			this.searchTerm = item.name;
			this.showSuggestions = false;
		},
		onEnterKey() {
    if (!this.searchTerm.trim()) {
      this.filters.corporate = "";
    }
  },
		showCreateJointCustomer() {
			let invalid = false
			this.selectedRows.forEach((item) => {
				if (item.cjp_id) {
					invalid = true
				}
			})
			if (invalid) {
				_gNotif.errorFunction(null, 'Invalid selection')
			} else {
				this.modals.show_create_joint_customer = true
			}
		},
		getCustomers() {
			this.isTableLoading = true
			axios.get(services.customer + 'customers', {
				params: {
					paginate: this.pagination.perPage,
					page: this.pagination.currentPage,
					customer_id: this.filters.customer_id,
					name: this.filters.customer_name,
					status: this.filters.status,
					channel: this.filters.channel,
					platform: this.filters.platform,
					ssa: this.filters.ssa,
					se: this.filters.se,
					sse: this.filters.sse,
					filter: this.filters.searchQuery,
					cards: this.filters.cardStatus,
					created_at: this.filters.created_at,
					updated_at: this.filters.updated_at,
					nric: this.filters.nric,
					income_type_id: this.filters.income_type_id,
					monitoring: this.filters.monitoring,
					beyond_tat: this.filters.beyond_tat,
					is_joint: this.filters.is_joint,
					core_product: this.filters.core_product,
					corporate: this.filters.corporate,
					created_by: this.filters.created_by,
					period: this.filters.period,
					send_to_advisory: this.$route.path == '/loanAdvisoryListingCount' ? 1 : null,
				},
				headers: getHeader()
			})
				.then(res => {
					this.current_customer_ids = []
					const data = res.data.data.data
					this.isTableLoading = false
					this.tableData = data
					this.pagination.currentPage = res.data.data.meta.current_page
					this.pagination.perPage = Number(res.data.data.meta.per_page)
					this.pagination.total = res.data.data.meta.total
					this.pagination.from = res.data.data.meta.from
					this.pagination.to = res.data.data.meta.to
					this.pagination.to = res.data.to
					for (let i = 0; i < data.length; i++) {
						this.current_customer_ids.push(data[i].customer_id)
					}
					this.getProfileListMessagesSummaries('customer', this.tableData);

					if (res.data.data.period_counts) {
						this.periodCounts = res.data.data.period_counts;
					}
				})
				.catch(e => {
					this.isTableLoading = false
					_gNotif.errorFunction(e)
				})
		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		emptySelection() {
			this.$refs.multipleTable.clearSelection()
		},
		paginationChanged(page) {
			history.pushState({}, null, this.$route.path + '?page=' + encodeURIComponent(page))
			this.currentPageChanged(page)
			this.pagination.currentPage = page
			this.getCustomers()
		},
		perPageChanged() {
			this.pagination.currentPage = this.listing_current_page
			this.getCustomers()
		},
		setFixed() {
			this.isFixed = window.innerWidth > 768;
		},
		generateRandomProposalId() {
			const randomDigits = Math.floor(100 + Math.random() * 900); // Generates a random 4-digit number
			const randomAlphabet = String.fromCharCode(65 + Math.floor(Math.random() * 26)); // Generates a random lowercase alphabet
			return `5${randomDigits}-${randomAlphabet}`;
		},
		getCustomerStatus() {
			axios.get(services.customer + 'customer/statuses', { headers: getHeader() })
				.then(res => {
					this.customerSubStatusList = res.data.data
						.filter((status) => status.group == "sub" ? status : "")
						.sort(function (a, b) {
							if (a.parent_status && b.parent_status) {
								if (a.parent_status < b.parent_status) {
									return -1;
								}
								if (a.parent_status > b.parent_status) {
									return 1;
								}
							}
							return 0;
						})
					this.customerStatusList = res.data.data
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		updateCustomerStatus(customer_id, status_id, app_code) {
			const baseHeaders = getHeader();
			const headers = {
				...baseHeaders,
				'Application-Code': app_code
			};
			axios.put(services.customer + 'customer/' + customer_id + '/status/' + status_id, {}, { headers: headers })
				.then(async res => {
					this.tableData = []
					this.getCustomers()
					this.getCustomerCountHandler()
					_gNotif.notifySuccess('<b>Customer Status - Successfully Updated.')
					let sub_status = this.customerSubStatusList.find(sub => sub.status_id == status_id);

					const notificationTemplate = await this.fetchNotificationTemplate('CUSTOMER_STATUS_CHANGE')
					if (notificationTemplate && notificationTemplate.is_active) {
						let message = notificationTemplate.notif_temp_message

						const recipients = notificationTemplate.notif_temp_receiver.split(',').map(id => parseInt(id.trim(), 10));
						let contentNotification = {
							noti_message: `Customer #${customer_id} : ${message} status:  ${sub_status.status}`,
							noti_url: window.location.origin + '/customerProfile',
							microservice_code: 'customer',
							noti_related_type: 'customer',
							noti_related_id: this.$route.params.customer_id
						}
						for (const recipient of recipients) {
							if (!isNaN(recipient)) { // Check if recipient is a valid integer
								let notification = { ...contentNotification, noti_user_id: recipient };

								// let notification = { ...contentNotification, noti_user_id: recipients }

								this.createNotification(notification)
							}
						}
					}
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		generateMainStatus(status_id) {

			const matchedData = this.customerStatusList.find((data) => data.status_id == status_id);
			return matchedData ? matchedData.status : "";

		},
		getClockIconColor(tracking_color) {
			switch (tracking_color) {
				case 'green':
					return 'text-success'; // Change to green color class
					break;
				case 'yellow':
					return 'text-warning'; // Change to yellow color class
					break;
				case 'red':
					return 'text-danger'; // Change to red color class
					break;
				default:
					return 'text-primary'; // Change to blue color class
					break;
			}
		},
		async getCustomerCountHandler() {
			try {
				const res = await this.getCustomerCount({
					customer_id: this.filters.customer_id,
					name: this.filters.customer_name,
					status: this.filters.status,
					channel: this.filters.channel,
					platform: this.filters.platform,
					ssa: this.filters.ssa,
					se: this.filters.se,
					sse: this.filters.sse,
					filter: this.filters.searchQuery,
					cards: this.filters.cardStatus,
					created_at: this.filters.created_at,
					updated_at: this.filters.updated_at,
					nric: this.filters.nric,
					monitoring: this.filters.monitoring,
					beyond_tat: this.filters.beyond_tat,
					is_joint: this.filters.is_joint,
					core_product: this.filters.core_product,
					corporate: this.filters.corporate,
					created_by: this.filters.created_by,
					send_to_advisory: this.$route.path == '/loanAdvisoryListingCount' ? 1 : null,
				})
				this.card_filters = res.data.data.count
			} catch (e) {
				_gNotif.errorFunction(e)
			}
		},
		handleFilterChangeCorporate(val) {
			this.filters.corporate = val
			this.getCustomers()
		},
		handleFilterChannelImoney(val) {
			const imoneyCorpId = 50;
			const corporateItem = this.corporateList.find(item => item.id === imoneyCorpId);
			const imoneyChId = corporateItem.setting_json.alt_channel.id;

			this.filters.corporate = val == imoneyChId ? imoneyCorpId : this.filters.corporate;
			this.filters.channel = val == imoneyChId ? '' : this.filters.channel;
		},
		selectProfileButton(index) {
			this.profile_type = index
			if (index === 1) {
				this.filters.is_joint = ''
				this.filters.monitoring = ''
				this.filters.beyond_tat = ''
			}
			if (index === 2) {
				this.filters.is_joint = 0
				this.filters.monitoring = ''
				this.filters.beyond_tat = ''
			}
			if (index === 3) {
				this.filters.is_joint = 1
				this.filters.monitoring = ''
				this.filters.beyond_tat = ''
			}
			if (index === 4) {
				this.filters.is_joint = ''
				this.filters.monitoring = 1
				this.filters.beyond_tat = ''
			}
			if (index === 5) {
				this.filters.is_joint = ''
				this.filters.monitoring = ''
				this.filters.beyond_tat = 1
			}
			this.filters.cardStatus = 'All'
			this.pagination.currentPage = 1
			this.sub_status = []
			this.getCustomers()
			this.getCustomerCountHandler()
		},
		selectFilterButton(button) {
			this.pagination.currentPage = 1
			this.sub_status = []
			this.filters.cardStatus = button;
			this.getCustomers()
		},
		customSortKey(row) {
			return parseFloat(row.incomes.main.net_income);
		},
		filterByDate($e) {
			this.selectedDates = []
			if ($e) {
				$e.forEach(element => {
					this.selectedDates.push(element)
				});
			}
			this.getCustomers()
		},
		assignToModal(customerAssigned, showSSA, showSSE, showHubManager = false) {
			this.modals.show_assign_customers_to = true
			this.selectedCustomerRow = customerAssigned
			this.showSSA = showSSA
			this.showSSE = showSSE
			this.showHubManager = showHubManager
			
			this.$refs.multipleTable.clearSelection()
		},
		bulkAssignToModal() {
			this.modals.show_assign_customers_to = true
			this.selectedCustomerRow = {}
			this.showSSA = true
			this.showSSE = true
			if (this.$route.path == '/loanAdvisoryListingCount') {
				this.showHubManager = true
			}
		},
		refreshTableData() {
			this.modals = {
				show_assign_customers_to: false,
				show_set_customers_status: false,
				show_create_joint_customer: false
			},
				this.tableData = []
			this.getCustomers()
			this.getCustomerCountHandler()
		},
		closeAssignModal() {
			this.showSSA = true
			this.showSSE = true
		},
		copyToClipboard(customer) {
			let value = null
			if (customer.cjp_id) {
				customer.customer_joint_profiles.forEach((item) => {
					if (!value) {
						value = item.name
					} else {
						value = value + '+' + item.name
					}
				})
			} else {
				value = customer.name
			}
			const tempInput = document.createElement('input');
			tempInput.value = value;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);

			// this.notifySuccess('<b>Customer Name:</b> Copied to Clipboard')
			_gNotif.notifySuccess('<b>Customer Name:</b> ' + value + '<br>Copied to Clipboard.')
		},
		filterAssignedTo(event) {
			if (event.date_type == 1) {
				this.filters.updated_at = ''
				this.filters.created_at = event.date_range
			} else if (event.date_type == 2) {
				this.filters.created_at = ''
				this.filters.updated_at = event.date_range
			} else {
				this.filters.created_at = ''
				this.filters.updated_at = ''
			}
			this.filters.se = event.se
			this.filters.ssa = event.ssa
			this.filters.sse = event.sse
			this.filters.customer_name = event.customer_name
			this.filters.customer_id = event.customer_id
			this.filters.status = event.status
			this.filters.end_date = event.end_date
			this.filters.channel = event.channel
			this.filters.platform = event.platform
			this.filters.nric = event.nric
			this.filters.core_product = event.core_product
			this.filters.corporate = event.corporate
			this.filters.created_by = event.created_by
			this.filters.income_type_id = event.income_type_id,
				this.filters.cardStatus = 'All'
			this.pagination.currentPage = 1

			this.handleFilterChannelImoney(event.channel)
			this.setFilterParams(this.filters)
			this.setFilterQuery(event)
			this.getCustomers()
			this.getCustomerCountHandler()
		},
		setFilterParams(queryfilters) {
			this.currentPageChanged(1)
			const queryParams = []

			// Loop through each key in the filters object
			for (const key in queryfilters) {
				// Check if the filter value is not empty
				if (queryfilters[key] !== '' && queryfilters[key] !== undefined) {
					// Append key-value pair to the queryParams array
					queryParams.push(`${key}=${encodeURIComponent(queryfilters[key])}`)
				}
			}

			// Construct the query string by joining the queryParams array with '&'
			const queryString = queryParams.length > 0 ? '?' + queryParams.join('&') : ''

			// Update the browser's URL using history.pushState
			history.pushState({}, null, this.$route.path + '?page=' + this.listing_current_page + queryString)
		},
		getLoanAdvisoryStatus() {
			axios.get(services.lookup + 'loan_advisory_status', { headers: getHeader() })
				.then(res => {
					const applicationCode = _gAuth.appCode();
					const corporateId = _gAuth.activeCorporateId();
					if (corporateId) {
						this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub' && item.corporate_id === corporateId);
					}
					else if (applicationCode) {
						this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub' && item.application_code === applicationCode);
					} else {
						this.loanAdvisorySubStatusList = res.data.data.filter((item) => item.group === 'sub')
					}
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
		},
		async updateCustomerAdvisoryStatus(customer_id, status_id) {
			try {
				await this.updateCustomerAdvisoryStat(customer_id, status_id);
				this.tableData = [];
				this.getCustomers();
			} catch (e) {
				console.error(e);
			}
		},
		// updateCustomerAdvisoryStatus(customer_id, status_id) {
		//     axios.put(services.customer + 'customer/' + customer_id + '/loan_advisory_status/' + status_id, {}, { headers: getHeader() })
		//         .then(res => {
		//             this.tableData = []
		//             this.getCustomers()
		//             this.notifySuccess('<b>Customer Loan Advisory Status - Successfully Updated.')
		//         })
		//         .catch(e => {
		//             _gNotif.errorFunction(e)
		//         })
		// },
		exportToGoogleCalendar(appointmentAt, leadName) {
			// Check if appointmentAt is not empty
			if (!this._gHlp.isEmpty(appointmentAt)) {
				// Format the appointment date for the Google Calendar link
				const formattedDate = this.formatGoogleCalendarDate(appointmentAt);
				// Create the Google Calendar link
				const googleCalendarLink = this.generateGoogleCalendarLink(formattedDate, leadName);
				// Open the link in a new tab
				window.open(googleCalendarLink, '_blank');
			}
		},

		formatGoogleCalendarDate(appointmentAt) {
			const date = new Date(appointmentAt);
			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, '0');
			const day = date.getDate().toString().padStart(2, '0');
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			const seconds = date.getSeconds().toString().padStart(2, '0');

			return `${year}${month}${day}T${hours}${minutes}${seconds}`;
		},

		generateGoogleCalendarLink(formattedDate, leadName) {
			// Generate Google Calendar link with necessary details
			const googleCalendarLink = `https://www.google.com/calendar/render?action=TEMPLATE&dates=${formattedDate}/${formattedDate}&text=${leadName}&details=Your%20appointment%20description%20goes%20here.&location=Appointment%20Location&sf=true&output=xml`;

			return googleCalendarLink;
		},

		getAltChannel(corporate) {
			if (corporate) {
				const corporateItem = this.corporateList.find(item => item.name === corporate);
				const channel = corporateItem?.setting_json?.alt_channel;
				if (channel) {
					return channel.name;
				}
			}
			return 'N/A';
		},

		getAltPlatform(corporate) {
			if (corporate) {
				const corporateItem = this.corporateList.find(item => item.name === corporate);
				const platform = corporateItem?.setting_json?.alt_platform;
				if (platform) {
					return platform.name;
				}
			}
			return 'N/A';
		},

		deleteRow(customer) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					if (customer.counts.count_product || customer.counts.count_proposal) {
						_gNotif.notifyError('The delete feature can only be used with customers that have no existing cases or proposals.');
						return
					}

					axios.delete(services.customer + 'customers/' + customer.customer_id, { headers: getHeader() })
						.then(res => {
							this.getCustomers()
							this.getCustomerCountHandler()
							_gNotif.notifySuccess('<b>Customer Record: </b> - Successfully Deleted.')
							return
						})
						.catch(e => {
							this.isTableLoading = false
							_gNotif.errorFunction(e)
						})
				}
			})
		},

		bulkDeleteRow(selectedCustomers) {
			let data = {
				customer_ids: selectedCustomers.map(item => item.customer_id)
			}
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					let customersWithCases = [];

					selectedCustomers.forEach(customer => {
						if (customer.counts.count_product || customer.counts.count_proposal) {
							customersWithCases.push(customer.name);
						}
					});

					if (!this._gHlp.isEmpty(customersWithCases)) {
						const customerNames = customersWithCases.join(', ');
						_gNotif.notifyError(`The bulk delete feature can only be used with customers that have no existing cases or proposals. See customers: '${customerNames}'`);
						return;
					}

					axios.post(services.customer + 'customers/bulk-delete', data, { headers: getHeader() })
						.then(res => {
							this.getCustomers()
							this.getCustomerCountHandler()
							_gNotif.notifySuccess('<b>Customer Record: </b> - Successfully Deleted.')
							return
						})
						.catch(e => {
							this.isTableLoading = false
							_gNotif.errorFunction(e)
						})
				}
			})
		},

		filterPeriod(period) {
			this.filters.period = period;
			this.pagination.currentPage = 1;
			
			this.filters.created_at = "";
			this.filters.updated_at = "";
			
			this.getCustomers();
			this.getCustomerCountHandler();
		},
	}

}
</script>
